/**
 * Silent / panic mode shared across pages.
 * - Persists preference in localStorage (`rr_silent_mode`).
 * - Provides a tiny store with subscribe/set semantics.
 *
 * When ON:
 *   - SOS hold progress ring is hidden (no visible feedback during press).
 *   - No success modal, no toast.
 *   - Single short vibration (200ms) when alert is dispatched.
 *   - The rest of the app keeps working — alert is still recorded in History.
 */

const KEY = "rr_silent_mode";

const listeners = new Set();

const read = () => {
  try { return localStorage.getItem(KEY) === "1"; }
  catch (_e) { return false; }
};

let current = read();

export const silentMode = {
  get() { return current; },
  set(v) {
    current = !!v;
    try {
      if (current) localStorage.setItem(KEY, "1");
      else localStorage.removeItem(KEY);
    } catch (e) { /* noop */ void e; }
    listeners.forEach((fn) => { try { fn(current); } catch (e) { /* noop */ void e; } });
  },
  subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};

export const vibrate = (pattern = 200) => {
  try {
    if (typeof navigator !== "undefined" && navigator.vibrate) {
      navigator.vibrate(pattern);
    }
  } catch (e) { /* noop */ void e; }
};
